<template>
  <div>
    <PrimaryButton light @click.native="openDialog" shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <ProfilePreferencesDialog
      :isOpen="isDialogOpen"
      @close="closeDialog"
      v-if="isDialogOpen"
      isEditMode
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ProfilePreferencesDialog from "@/components/profile/ProfilePreferencesDialog";

export default {
  name: "EditPreferencesAction",
  components: { PrimaryButton, ProfilePreferencesDialog },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
